<app-company-edit-info
  #editInfoForm
  *ngIf="companiesService.screen === steps.INFO"
  class="info-container middle-scrollable enable-click"
>
</app-company-edit-info>

<div fxLayout="row" fxLayoutGap="20px" class="footer">
  <div class="right">
    <button class="center-button enable-click" mat-raised-button color="primary" (click)="onBack()">
      {{ 'Settings.Back' | translate }}
    </button>
    <button
      class="center-button enable-click"
      mat-raised-button
      color="primary"
      (click)="onNext()"
      [disabled]="checkDisabledByStage()"
    >
      {{ 'Panel.Save' | translate }}
    </button>
  </div>
</div>
